import { render, staticRenderFns } from "./DetectionWriteUrlLayout.vue?vue&type=template&id=4b12b285&scoped=true"
import script from "./DetectionWriteUrlLayout.vue?vue&type=script&lang=js"
export * from "./DetectionWriteUrlLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b12b285",
  null
  
)

export default component.exports